import React from 'react'
import DocumentSubmission from '../../components/DocumentSubmission/DocumentSubmission'

const Document_Submission = () => {
	return (
		<div>
			<DocumentSubmission />
		</div>
	)
}


export default Document_Submission